import React, {useEffect, useState} from 'react';
import Search from "../search/search";
import {DeleteIcon, EditIcon} from "../../icons/icons";
import Pagination from "../pagination/pagination";
import DropDown from "../../assets/dropDown/dropDown";
import Sort from "../sort/sort";
import {GetViewType} from "../../utils/view-type";
import Filter from "../filter/filter";
import {useTranslation} from "react-i18next";
import {Delete, Get} from "../../apis/api";
import LoadingFix from "../loading-fix/loading-fix";
import DeleteModal from "../deleteModal/deleteModal";
import {toast} from "react-toastify";

const AirlineTable = ({defaultValue , editItem}) => {
  const viewType = GetViewType()
  const {t} = useTranslation();

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState( [])
  const [deleteItem, setDeleteItem] = useState( null )
  const [loadingDelete, setLoadingDelete] = useState( false )
  const [perPage, setPerPage] = useState( 10 )
  const [searchTime, setSearchTime] = useState("")

  useEffect(() => {
    handleList()
  } ,[])

  useEffect(() => {
    setData(defaultValue)
  } ,[defaultValue])

  const handleList = (page , per_page, search="") => {
    setLoading(true)
    Get(`basic-information/airline?page=${page || 1}&per_page=${per_page || 10}&q=${search}` ).then((res) =>{
      setData(res?.details?.data)
    }).finally(() => {
      setLoading(false)
    })
  }
  const handleEdit = (item) => {
    editItem(item)
  }

  const handleDelete = (item) => {
    setDeleteItem(item)
  }

  const handleCloseDeleteModal = () => {
    setDeleteItem(null)
  }

  const handleDeleteRequest = () => {
    setLoadingDelete(true)
    Delete(`basic-information/airline/destroy/${deleteItem.id}` ).then((res) =>{
      setData(res?.details?.data)
      toast.success(res.msg)
      setDeleteItem(null)
    }).finally(() => {
      setLoadingDelete(false)
    })
  }

  const handleSort = (e) => {
    setData([])
    setTimeout(() => {
      setData(e)
    } ,0)
  }
  const handleSearch = (e) => {

    clearTimeout(searchTime)


    let loop = setTimeout(() => {

      handleList(1 , perPage , e);

    }, 1000)
    setSearchTime(loop)

  }
  const otpList = [
    {id:1 , name:"فعال"},
    {id:0 ,name:"غیر فعال"},
  ]
  const handleOtp = (id) => {
    return otpList?.find((item => {
      return (
        item.id === id
      )
    }))?.["name"]
  }
  return (
    <div className={"my-container"}>
      {
        loading && <LoadingFix/>
      }
      {
        deleteItem && <DeleteModal onClose={handleCloseDeleteModal} onDelete={handleDeleteRequest} loading={loadingDelete}/>
      }
      {
        viewType === "WEB" ?
          <div className="relative overflow-x-auto w-full  bg-white rounded-lg  flex flex-col items-center w-full !mt-5 border border-1 border-gray-300 overflow-hidden ">
            <table className="w-full text-sm text-gray-500">
              <thead className="text-xs text-gray-700 uppercase ">
              <tr className={"border-b border-gray-400"}>
                <th scope="col" className="px-6 py-3 text-left w-4 font-normal text-gray-600 text-sm">
                  <div className={"mt-1"}>
                    {t("row")}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3  text-right font-normal text-gray-600 text-sm">
                  <div className={"mt-1 flex"}>
                    <Sort data={data} sortKey={"fa_name"}  onSort={(e)=> handleSort(e)}/>
                    {t("faName")}
                  </div>
                </th>

                <th scope="col" className=" py-3 text-left font-normal text-gray-600 text-sm ">
                  <div className={`mt-1 flex justify-center`}>
                    <Sort data={data} sortKey={"en_name"}  onSort={(e)=> handleSort(e)}/>
                    {t("enName")}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-center font-normal text-gray-600 text-sm ">
                  <div className={`mt-1 flex justify-center`}>
                    <Sort data={data} sortKey={"email"}  onSort={(e)=> handleSort(e)}/>
                    {t("email")}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-center font-normal text-gray-600 text-sm ">
                  <div className={`mt-1 flex justify-center`}>
                    <Sort data={data} sortKey={"otb"}  onSort={(e)=> handleSort(e)}/>
                    {t("otb")}
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-left w-[200px] font-normal text-gray-600 text-sm">
                  <Search onChange={handleSearch}/>
                </th>
              </tr>
              </thead>
              <tbody>
              {data?.data?.map((item, index) => (
                <tr key={index} className="bg-white border-b border-gray-400">
                  <td className="px-6 py-4 text-center">
                    <div className={"text-gray-500 text-sm mt-1"}>
                      {index + 1}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-start text-primary-400 text-base font-semibold">
                    <div className={"mt-1"}>
                      {item.fa_name}
                    </div>
                  </td>

                  <td className="px-6 py-4 text-center text-primary-400 text-base font-semibold">
                    <div className={"mt-1"}>
                      {item.en_name}
                    </div>
                  </td>

                  <td className=" py-4 text-center">
                    <div className={"text-gray-900 text-sm mt-1"}>
                      {item.email}
                    </div>
                  </td>
                  <td className=" py-4 text-center">
                    <div className={"text-gray-900 text-sm mt-1"}>
                      {handleOtp(item.otb)}
                    </div>
                  </td>

                  <td className="px-6 py-4 text-right">
                    <div className={"flex justify-center cursor-pointer"}>
                      <button onClick={()=>handleEdit(item)}>
                        <EditIcon/>
                      </button>
                      <button onClick={()=>handleDelete(item)}>
                        <DeleteIcon/>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          </div>
          :
          <div className={"grid gap-3 mt-3"}>
            <div className={"bg-white p-3 rounded-lg flex gap-5"}>
              <Filter/>
              <div className={"w-full"}>
                <Search onChange={handleSearch}/>
              </div>
            </div>
            {
              data?.data?.map((item , index) => {
                return(
                  <div className={"flex p-4 rounded-lg bg-white"}>
                    <div className={"flex w-full"}>
                      <div className={"ml-5 min-w-7"}>{index + 1}</div>
                      <div className={"flex w-full flex-wrap gap-y-8 justify-between"}>
                        <div className={"flex w-1/3"}>{item.fa_name}</div>
                        <div className={"flex w-1/3 text-sm text-gray-900 text-center justify-center"}>{item.en_name}</div>
                        <div className={"flex w-1/3 text-sm text-gray-900"}> {handleOtp(item.otb)}</div>
                        <div className={"flex w-full text-sm text-gray-900 text-left justify-start"}>{item.email}</div>
                        <div className={"flex w-full justify-end"}>
                          <div className={"flex justify-center cursor-pointer"}>
                            <button onClick={()=>handleEdit(item)}>
                              <EditIcon/>
                            </button>
                            <button onClick={()=>handleDelete(item)}>
                              <DeleteIcon/>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
      }
      <div className={'flex flex-col  md:flex-row md:items-center md:justify-between mt-4'}>
        <DropDown onChange={(per_page) => {
          handleList(1, per_page)
          setPerPage(per_page)
        }}/>
        <Pagination itemsPerPage={data?.per_page} total={data?.total} last_page={data?.last_page}  changePage={(page) => handleList(page , perPage)}/>
      </div>
    </div>
  );
};


export default AirlineTable;

